import { apiUrl } from '../../config.json';
import axios from 'axios'
const token = localStorage.getItem('authToken')
const apiEndPoint = apiUrl + "/collections/items"
axios.interceptors.request.use(
    config => { 
        config.headers.authorization = `Bearer ${token}`;
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

export async function fileSending(id ,email) {
    let response = await axios.post(apiEndPoint + "/shareFile/" + id ,{
       email:email  
    })
    return await response.data
}
export async function fetchFiles(id) {
    let response = await axios.get(apiEndPoint +"/"+ id + "/viewFiles")
    return await response.data
}

export default {
   fileSending,
   fetchFiles
}